import React, { useEffect, useMemo } from 'react';
import { Button, Card, Form, Spin, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import { LoadingOutlined } from '@ant-design/icons';

import enImg from '@assets/img/EN.png';
import ruImg from '@assets/img/RU.png';

export default function BasicSettings({ loading, pending, settings, onSave }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const values = useMemo(
    () => ({
      language: settings.language,
      timeFormat: settings.timeFormat,
      firstWeekDay: settings.firstWeekDay,
    }),
    [settings]
  );

  useEffect(() => {
    form.setFieldsValue(values);
  }, [values]);

  return (
    <Card
      className="settings-card"
      title={t('basic-settings')}
      bordered={false}
    >
      <Spin spinning={loading} indicator={<LoadingOutlined />}>
        <Form
          form={form}
          layout="vertical"
          name="basic-settings-edit"
          onFinish={onSave}
        >
          <Form.Item name="language" label={t('language')}>
            <Select>
              <Select.Option value="EN">
                <img
                  src={enImg}
                  alt="English"
                  className="settings-basic__lang-icon"
                />
                English
              </Select.Option>
              <Select.Option value="RU">
                <img
                  src={ruImg}
                  alt="Russian"
                  className="settings-basic__lang-icon"
                />
                Русский
              </Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="timeFormat" label={t('time-format')}>
            <Select>
              <Select.Option value={true}>{t('time-format-24')}</Select.Option>
              <Select.Option value={false}>{t('time-format-12')}</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="firstWeekDay" label={t('first-week-day')}>
            <Select>
              <Select.Option value={0}>{t('monday')}</Select.Option>
              <Select.Option value={6}>{t('sunday')}</Select.Option>
            </Select>
          </Form.Item>
          <Button htmlType="submit" type="default" loading={pending}>
            {t('save')}
          </Button>
        </Form>
      </Spin>
    </Card>
  );
}
